var _defs, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconVideoOnGreen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_video_on_green",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .video-on-class-a {\n        fill: none !important;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M19.2,21.336H5.489V8.493H19.2M20.333,6h-16A1.42,1.42,0,0,0,3,7.487V22.353A1.42,1.42,0,0,0,4.333,23.84h16a1.42,1.42,0,0,0,1.333-1.487v-5.2L27,21.336V8.493l-5.333,4.2v-5.2A1.42,1.42,0,0,0,20.333,6Z",
    transform: "translate(1 1)",
    fill: "#3dcc84"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2745",
    className: "video-on-class-a",
    "data-name": "Rectangle 2745",
    width: 32,
    height: 32
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconVideoOnGreen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_video_on_green.124e9065d75766988f4d783ffd6a43c1.svg";